import { postForm, request } from './client'
import { USE_MOCK } from './config'
import { mockAnalysisApi } from './mock'

export const analysisApi = USE_MOCK ? mockAnalysisApi : {
  update: (project_id: string) =>
    postForm('/analysis/update', { project_id }),

  dataOverview: (project_id: string, time_period: number) =>
    postForm('/analysis/dataOverview', { project_id, time_period }),

  emotionalProportion: (project_id: string, time_period: number) =>
    postForm('/analysis/emotionalProportion', { project_id, time_period }),

  planWordHit: (project_id: string, time_period: number) =>
    postForm('/analysis/planWordHit', { project_id, time_period }),

  keywordEmotionTrend: (project_id: string, time_period: number) =>
    postForm('/analysis/keywordEmotionTrend', { project_id, time_period }),

  hotEventRanking: (project_id: string, time_period: number) =>
    postForm('/analysis/hotEventRanking', { project_id, time_period }),

  highwordCloud: (project_id: string, time_period: number) =>
    postForm('/analysis/highwordCloud', { project_id, time_period }),

  popularInformation: (project_id: string, time_period: number) =>
    postForm('/analysis/popularInformation', { project_id, time_period }),

  popularEvent: (project_id: string, time_period: number) =>
    postForm('/analysis/popularEvent', { project_id, time_period }),

  hotCompany: (project_id: string, time_period: number) =>
    postForm('/analysis/hotCompany', { project_id, time_period }),

  hotPeople: (project_id: string, time_period: number) =>
    postForm('/analysis/hotPeople', { project_id, time_period }),

  hotSpot: (project_id: string, time_period: number) =>
    postForm('/analysis/hotSpot', { project_id, time_period }),

  topicCluster: (project_id: string, time_period: number) =>
    postForm('/analysis/topicCluster', { project_id, time_period }),

  keywordExposureRank: (project_id: string, time_period: number) =>
    postForm('/analysis/keywordExposureRank', { project_id, time_period }),

  selfmediaVolumeRank: (project_id: string, time_period: number) =>
    postForm('/analysis/selfmediaVolumeRank', { project_id, time_period }),

  mediaActivityAnalysis: (project_id: string, time_period: number) =>
    postForm('/analysis/mediaActivityAnalysis', { project_id, time_period }),

  dataSourceDistribution: (project_id: string, time_period: number) =>
    postForm('/analysis/dataSourceDistribution', { project_id, time_period }),

  dataSourceAnalysis: (project_id: string, time_period: number) =>
    postForm('/analysis/dataSourceAnalysis', { project_id, time_period }),

  keywordIndex: (project_id: string, time_period: number) =>
    postForm('/analysis/keywordIndex', { project_id, time_period }),

  relativeNews: (project_id: string, time_period: number) =>
    postForm('/analysis/relativeNews', { project_id, time_period }),

  categoryRank: (project_id: string, time_period: number) =>
    postForm('/analysis/categoryRank', { project_id, time_period }),

  industrialDistribution: (project_id: string, time_period: number) =>
    postForm('/analysis/industrialDistribution', { project_id, time_period }),

  eventStatistics: (project_id: string, time_period: number) =>
    postForm('/analysis/eventStatistics', { project_id, time_period }),

  keywordEmotionStatistical: (project_id: string, time_period: number) =>
    postForm('/analysis/keywordEmotionStatistical', { project_id, time_period }),
}
